import {gql} from '@apollo/client';
import {call} from 'redux-saga/effects';
import apolloClient from '../store/apolloClient';

const getUserData = () => {
  const userGql = gql`
    {
      ssoUser
    }
  `;
  return apolloClient.query({
    fetchPolicy: 'no-cache',
    query: userGql,
  });
};

const getUserDataGenerator = () => {
  const userGql = gql`
    {
      ssoUser
    }
  `;
  return call(apolloClient.query, {
    fetchPolicy: 'no-cache',
    query: userGql,
  });
};

export const parseJwt = (token) => {
  const base64Url = token.split('.')[1];
  const base64 = base64Url?.replace(/-/g, '+')?.replace(/_/g, '/') || '';
  if (!base64) {
    return base64;
  }
  const jsonPayload = decodeURIComponent(
    window
      .atob(base64)
      .split('')
      .map(c => `%${`00${c.charCodeAt(0).toString(16)}`.slice(-2)}`)
      .join(''),
  );

  return JSON.parse(jsonPayload);
};

export const setToken = (token, publicToken = false) =>
  window.localStorage.setItem(publicToken ? 'gridics-public-token' : 'gridics-token', token);
export const getToken = (publicToken = false) =>
  window.localStorage.getItem(publicToken ? 'gridics-public-token' : 'gridics-token') || '';
export const clearToken = (publicToken = false) =>
  window.localStorage.removeItem(publicToken ? 'gridics-public-token' : 'gridics-token');
export const updateToken = async () => {
  const newUserData = (await getUserData())?.data?.ssoUser;
  const newToken = newUserData.gridicsApiPublicToken || '-1';
  setToken(newToken, true);
  setToken(newUserData.token);

  return newToken;
};

export const verifyJWTToken = (token) => {
  const decodedToken = parseJwt(token);
  return !(!decodedToken || decodedToken.exp - 60 < Math.floor(Date.now() / 1000));
};

export const getActualPublicToken = async () => {
  const token = getToken(true);
  if (!verifyJWTToken(token)) {
    return updateToken();
  }
  return token;
};

function* updateTokenGenerator() {
  const newUserData = (yield getUserDataGenerator())?.data?.ssoUser;
  const newToken = newUserData.gridicsApiPublicToken || '-1';
  setToken(newToken, true);
  setToken(newUserData.token);

  return newToken;
}

export function* getActualPublicTokenGenerator() {
  let token = getToken(true);
  if (!verifyJWTToken(token)) {
    token = yield updateTokenGenerator();
  }
  return token;
}
